import '../assets/css/main.css';
import NavBar from "../components/navbar";
import Footer from "../components/footer";

function Contact() {

    return(
        <>
            <NavBar />
            <main className="main">
                <section id="contact" className="contact section">
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Contact</h2>
                        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
                    </div>
                    <div className="container" data-aos="fade-up" data-aos-delay="100">
                        <div className="row gy-4">
                            <div className="col-lg-5">
                                <div className="info-wrap">
                                    <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="200">
                                        <i className="bi bi-geo-alt flex-shrink-0"></i>
                                        <div>
                                            <h3>Address</h3>
                                            <p>P.O. Box 801032, Santa Clarita, CA 91380-1032
                                            </p>
                                        </div>
                                    </div>
                                    <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="300">
                                        <i className="bi bi-telephone flex-shrink-0"></i>
                                        <div>
                                            <h3>Call Us</h3>
                                            <p>+1 323 496 9047</p>
                                        </div>
                                    </div>
                                    <div className="info-item d-flex" data-aos="fade-up" data-aos-delay="400">
                                        <i className="bi bi-envelope flex-shrink-0"></i>
                                        <div>
                                            <h3>Email Me</h3>
                                            <p>jose_bravo@hotmail.com</p>
                                        </div>
                                    </div>
                                    <iframe src="https://www.google.com/maps/embed/v1/place?q=Los+Angeles,+CA,+USA&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" title="Map showing Los Angeles, CA, USA" frameBorder="0"
                                            style={{border: '0', width: '100%', height: '270px'}} allowFullScreen={true} loading="lazy"
                                            referrerPolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <form action="forms/contact.php" method="post" className="php-email-form" data-aos="fade-up" data-aos-delay="200">
                                    <div className="row gy-4">
                                        <div className="col-md-6">
                                            <label className="pb-2">Your Name</label>
                                            <input type="text" name="name" id="name-field" className="form-control" required={true} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="pb-2">Your Email</label>
                                            <input type="email" className="form-control" name="email" id="email-field" required={true}/>
                                        </div>
                                        <div className="col-md-12">
                                            <label className="pb-2">Subject</label>
                                            <input type="text" className="form-control" name="subject" id="subject-field" required={true} />
                                        </div>
                                        <div className="col-md-12">
                                            <label  className="pb-2">Message</label>
                                            <textarea className="form-control" name="message" rows={10} id="message-field" required={true} />
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <div className="loading">Loading</div>
                                            <div className="error-message"></div>
                                            <div className="sent-message">Your message has been sent. Thank you!</div>
                                            <button type="submit">Send Message</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}

export default Contact;